
















































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import search from '@/store/modules/search';
import {PortfolioCompany} from '@/store/models';
import PortfolioCompanyItem from '@/views/PortfolioCompanyItem.vue';
import * as api from '@/store/api';

@Component({
    components: {PortfolioCompanyItem},
})
export default class Portfolio extends Vue {
  async mounted() {
    await search.setTerm('');
    await user.setActiveSie(null);
    await user.setSelectedSie(null);
    await user.setSelectedSieBlob(null);
  }

  async gotoPresentation(p: any) {
    await user.setSelectedDocument(p.Id);
    await user.setSelectedDocumentBlob(null);
    await user.setActiveExternalUser(p.UserIdEx);
    if (p.SubType === 'deck-template') {
      this.$router.push({name: 'templates', params: {OrgNr: '00'}});
    } else {
      this.$router.push({name: 'documents', params: {OrgNr: '00'}});
    }
  }

  async gotoCompany(OrgNr: string) {
        await user.setActiveExternalUser(null);
        this.$router.push({ name: 'overview', params: { OrgNr } });
    }

    get presentations(): any {
      if (!user.events) {
          return [];
      }
      return user.events.filter((e: any) => e.OrgNr === '00');
    }

    get companies(): PortfolioCompany[] | null {
        if (!user.companies) { return []; }

        const filter = user.companyFilter;
        return user.companies.filter((c: PortfolioCompany, index: number, array: PortfolioCompany[]) => {
            if (!filter) { return true; }
            if (c.OrgNr.includes(filter)) { return true; }
            if (c.Name.toLowerCase().includes(filter)) { return true; }
            return false;
        }).slice(0, 500);
    }

    get allCompanies(): PortfolioCompany[] | null {
        const companies = user.companies;
        if (companies === null) {
            return null;
        }
        return companies.sort( (a: PortfolioCompany, b: PortfolioCompany) => a.Name.localeCompare(b.Name));
    }
}
